export const modeConstants = {
  ADD_MODE: "ADD_MODE",
  UPDATE_MODE: "UPDATE_MODE",
  VIEW_MODE: "VIEW_MODE",
};
